import { FareFamilyRequestPayload } from '@/src/components/desktop/srp/fareFamily/types'
import { DeviceType } from '@/src/types/deviceType'
import { FlightCard, JsonsData } from '@/src/types/flight'
import { path } from '@/src/utils/generalUtils/path'
import { getCurrencyByLocale } from '../../currency/formatCurrency'
import { getFormattedDate } from '../../date'
import { getAppAgent } from '../../deviceType'

export const getFareFamilyRequestPayload = (
    card: FlightCard | null,
    urlQueryObj: Record<string, string>,
    deviceType: DeviceType,
    sid: string | null,
    jsons: JsonsData,
    isRTReturnLeg?: boolean
): FareFamilyRequestPayload => {
    let departDate = isRTReturnLeg ? urlQueryObj.return_date : urlQueryObj.depart_date || ''
    if (departDate) {
        departDate = getFormattedDate(departDate, 'YYYY-MM-DD')
    }

    if (!card) {
        throw new Error('Invalid flight card data')
    }

    const from = isRTReturnLeg ? urlQueryObj.to : urlQueryObj.from || ''
    const to = isRTReturnLeg ? urlQueryObj.from : urlQueryObj.to || ''
    const cabinType = urlQueryObj.class?.toUpperCase?.() || 'ECONOMY'
    // const returnDate = searchQueryObj.return_date || ''
    const adults = Number(urlQueryObj.adults || 1)
    const children = Number(urlQueryObj.childs || 0)
    const infants = Number(urlQueryObj.infants || 0)
    return {
        flightParams: [
            {
                onwardFares: [
                    {
                        basePrice: card.priceBreakup.fare.bp,
                        price: card.priceBreakup.pr,
                        fareKey: card.priceBreakup.fare.fk,
                        fareType: card.dfd === 'R' ? 'REFUNDABLE' : 'NON_REFUNDABLE',
                        fareClass: 'RETAIL',
                        solutionId: card.priceBreakup.fare.solutionId,
                        comboFBC: card.priceBreakup.fare.fb
                    }
                ],
                cabinType,
                departDate,
                from,
                returnDate: '',
                returnFares: [],
                to
            }
        ],
        paxInfo: {
            adults,
            children,
            infants
        },
        itineraryMeta: {
            appAgent: deviceType ? getAppAgent(deviceType) : 'N/A',
            utmCurrency: getCurrencyByLocale().currency,
            userAgent: path(['navigator', 'userAgent'], window)?.toLowerCase(),
            sourceType: deviceType === 'DESKTOP' ? 'B2C' : 'MOBILE',
            domain: jsons?.domain || 'FSA',
            sid: sid ?? '',
            userId: jsons?.userInfo?.usrId || ''
        }
    }
}
